import { Search, Plus } from 'lucide-react'

interface Props {
  searchQuery: string
  onSearchChange: (query: string) => void
  onNewInvoice?: () => void
}

export function ShiftBillingHeader({ searchQuery, onSearchChange, onNewInvoice }: Props) {
  return (
    <div className="flex items-start justify-between gap-6 mb-8">
      <div>
        <h2 className="font-headline text-5xl text-ml-primary tracking-tight leading-none">Facturación</h2>
        <p className="text-ml-on-surface-variant/70 font-medium mt-2 text-sm">
          Honorarios clínicos, estados de cuenta y pagos.
        </p>
      </div>

      <div className="flex items-center gap-3 shrink-0 mt-1.5">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-ml-on-surface-variant/50 pointer-events-none" />
          <input
            type="search"
            placeholder="Buscar paciente o factura..."
            className="bg-ml-surface-container-high border-none rounded py-2 pl-9 pr-4 text-sm w-64 focus:ring-1 focus:ring-ml-primary/20 transition-all placeholder:text-ml-on-surface-variant/40"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            aria-label="Buscar paciente o factura"
          />
        </div>

        {onNewInvoice && (
          <button
            onClick={onNewInvoice}
            className="flex items-center gap-1.5 bg-ml-primary text-white rounded px-4 py-2 text-xs font-bold shadow-md shadow-ml-primary/15 hover:opacity-90 transition-opacity shrink-0 whitespace-nowrap"
          >
            <Plus className="h-3.5 w-3.5" />
            Nueva Factura
          </button>
        )}
      </div>
    </div>
  )
}
